/**
 * PDP media carousel: main slider with Thumbs module.
 * Inits thumb Swiper first, then main Swiper with thumbs: { swiper }.
 * Expects: [data-pdp-thumb-desktop], [data-pdp-main-swiper] and scrollbar inside [data-carousel-id] ancestor.
 */
import Swiper from "swiper"
import { Navigation, Thumbs, Scrollbar } from "swiper/modules"

export default () => ({
  thumbSwiper: null,
  mainSwiper: null,
  initialized: false,

  init() {
    this.$nextTick(() => {
      this.initSliders()
    })
  },

  initSliders() {
    const thumbEl = this.$el.querySelector("[data-pdp-thumb-desktop]")
    const mainEl = this.$el.querySelector("[data-pdp-main-swiper]")
    const scrollbarEl = this.$el.closest("[data-carousel-id]")?.querySelector(".lsa-product-carousel__scrollbar")

    if (!thumbEl || !mainEl) return

    const thumbPrevEl = this.$el.querySelector("[data-pdp-thumb-prev]")
    const thumbNextEl = this.$el.querySelector("[data-pdp-thumb-next]")

    this.thumbSwiper = new Swiper(thumbEl, {
      modules: [Navigation, Thumbs],
      direction: "vertical",
      navigation:
        thumbPrevEl && thumbNextEl
          ? { prevEl: thumbPrevEl, nextEl: thumbNextEl }
          : false,
      spaceBetween: 8,
      slidesPerView: 5,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      watchOverflow: false,
      centeredSlidesBounds: true,
      centeredSlides: true,
      loopAdditionalSlides: 1,
      breakpoints: {
        0: { direction: "horizontal" },
        768: { direction: "vertical" },
      },
    })

    this.mainSwiper = new Swiper(mainEl, {
      modules: [Thumbs, Scrollbar],
      thumbs: { swiper: this.thumbSwiper },
      loop: false,
      watchSlidesProgress: true,
      scrollbar: scrollbarEl
        ? { el: scrollbarEl, draggable: true }
        : false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      watchOverflow: false,
      centeredSlidesBounds: true,
      centeredSlides: true,
    })

    this.initialized = true
  },
})
